import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_wellness-social-pro/artifacts/n1jvbl5e_logo-full-color-transparent.webp";

// Content Lab WhatsApp number (international format, digits only).
export const WHATSAPP_NUMBER = "919987540065";

export const whatsappLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const submitLead = async (payload) => {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
};

export const fetchLeads = async () => {
  const { data } = await axios.get(`${API}/leads`);
  return data;
};

export const scrollToId = (id, attempt = 0) => {
  const el = document.querySelector(id);
  if (!el) return;
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis && typeof lenis.scrollTo === "function") {
    lenis.scrollTo(el, { offset: -84, duration: 1.1 });
    return;
  }
  // Lenis not ready yet — retry briefly, then fall back to native scroll.
  if (attempt < 12) {
    setTimeout(() => scrollToId(id, attempt + 1), 60);
    return;
  }
  const y = el.getBoundingClientRect().top + window.pageYOffset - 84;
  window.scrollTo({ top: y, behavior: "smooth" });
};
